/* Project Import will be here */
import { post, IRequest } from "../dms/index";
import { IRetailerLedgerParams } from "../../models/reports/retailerLedgerModels";
/* Project Import will be here */

/* Get retailer ledger from DMS server */
export const getRetailerLedgerApi = (data: IRetailerLedgerParams) => {
    const request: IRequest = {
        subUrl: '/CustomerLedgerReport/Masters',
        data
    };

    return post(request);
};